import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../FirebaseAppContext';
import './DetailPages.css';

function getCustomerContactEmail(contactInfo?: string): string {
  if (!contactInfo) return 'N/A';
  const [emailPart] = contactInfo.split('|');
  return emailPart?.trim() || 'N/A';
}

function getCustomerContactPhone(contactInfo?: string): string {
  if (!contactInfo) return 'N/A';
  const [, phonePart] = contactInfo.split('|');
  return phonePart?.trim() || 'N/A';
}

export default function CustomerDetail() {
  const { customerId } = useParams<{ customerId: string }>();
  const navigate = useNavigate();
  const { state, customerOperations } = useAppContext();
  const customer = state.customers.find(c => c.id === customerId);

  if (!customer) {
    return (
      <div className="detail-page">
        <div className="detail-card detail-list">
          <p>Customer not found</p>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/customers')}>Back to Customers</button>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      try {
        await customerOperations.delete(customer.id);
        navigate('/customers');
      } catch (err) {
        alert('Failed to delete customer: ' + (err as Error).message);
      }
    }
  };

  return (
    <div className="detail-page">
      <div className="detail-header">
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/customers')}>← Back</button>
        <h1 className="detail-title">{customer.name}</h1>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(`/customers/${customer.id}/edit`)}>Edit</button>
        <button type="button" className="btn btn-primary" onClick={handleDelete}>
          Delete
        </button>
      </div>

      <div className="detail-card detail-list">
        <div className="detail-item"><span className="detail-item-label">Name</span><span className="detail-item-value">{customer.name}</span></div>
        <div className="detail-item"><span className="detail-item-label">Email</span><span className="detail-item-value">{customer.email || getCustomerContactEmail(customer.contactInfo)}</span></div>
        <div className="detail-item"><span className="detail-item-label">Phone</span><span className="detail-item-value">{customer.phone || getCustomerContactPhone(customer.contactInfo)}</span></div>
        <div className="detail-item"><span className="detail-item-label">Driver License</span><span className="detail-item-value">{customer.driverLicense}</span></div>
      </div>
    </div>
  );
}

